import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './SideDrawer.css'

function dropDownOm() {
  document.getElementById("om").classList.toggle("show");
}

function dropDownProducts() {
  document.getElementById("produkter").classList.toggle("show");
}

function dropDownMusik() {
  document.getElementById("musik").classList.toggle("show");
}

function dropDownTeater() {
  document.getElementById("teater").classList.toggle("show");
}

function dropDownUser() {
  document.getElementById("user").classList.toggle("show");
}

function dropDownOther() {
  document.getElementById("other").classList.toggle("show");
}


const sideDrawer = props => {

  let sideDrawerClasses = "side-drawer";

  if (props.show) {
    sideDrawerClasses = "side-drawer open";
  }

  return (
    <nav className={sideDrawerClasses}>
      <ul className="side-main-menu">
        <li className="side-menu-item">
          <a onClick={dropDownOm}>OM</a>
          <ul className="side-dropdown-menu" id="om">
            <li><Link to="/historia">Vår Historia</Link></li>
            <li><Link to="/snabbfakta">Snabbfakta</Link></li>
            <li><Link to="/karaktarerna">Karaktärer</Link></li>
            <li><Link to="/bocker">Böcker</Link></li>
            <li><Link to="/forlag">Förlag</Link></li>
            <li><Link to="/aterforsaljare">Återförsäljare</Link></li>
            <li><Link to="/upphovspersoner">Upphovspersoner</Link></li>
            <li><Link to="/medverkande">Medverkande</Link></li>
            <li><Link to="/licens">Licenser</Link></li>
          </ul>
        </li>

        <li className="side-menu-item">
          <a onClick={dropDownProducts}>PRODUKTER</a>
          <ul className="side-dropdown-menu" id="produkter">
            <li><Link to="/">Produkter</Link></li>
            <li><Link to="/">Webshop</Link></li>
          </ul>
        </li>

        <li className="side-menu-item">
          <a onClick={dropDownMusik}>MUSIK/MEDIA</a>
          <ul className="side-dropdown-menu" id="musik">
            <li><Link to="/">Musik</Link></li>
            <li><Link to="/">Youtube</Link></li>
            <li><Link to="/">Appar</Link></li>
            <li><Link to="/">Musikspelare</Link></li>
            <li><Link to="/">Skivor</Link></li>
            <li><Link to="/">Studio</Link></li>
            <li><Link to="/">Musikförlag/Label</Link></li>
            <li><Link to="/">Radiostationer</Link></li>
            <li><Link to="/">Kanaler</Link></li>
            <li><Link to="/">Upphovspersoner</Link></li>
          </ul>
        </li>

        <li className="side-menu-item">
          <a onClick={dropDownTeater}>TEATER</a>
          <ul className="side-dropdown-menu" id="teater">
            <li><Link to="/">Bioteater</Link></li>
            <li><Link to="/">Raffe Räv Hälsar På</Link></li>
            <li><Link to="/">Bokning</Link></li>
            <li><Link to="/">Biografer</Link></li>
            <li><Link to="/">Arrangörer</Link></li>
            <li><Link to="/">Teatergrupper</Link></li>
            <li><Link to="/">Egna Elevföreställningar På Skola/Förskola</Link></li>
            <li><Link to="/">Så Här Tycker Andra</Link></li>
          </ul>
        </li>

        <li className="side-menu-item">
          <a onClick={dropDownUser}>ANVÄNDARE</a>
          <ul className="side-dropdown-menu" id="user">
            <li><Link to="/">Förskola/Skola</Link></li>
            <li><Link to="/">Privata/Hem</Link></li>
            <li><Link to="/">Övrig Användare</Link></li>
          </ul>
        </li>

        <li className="side-menu-item">
          <a onClick={dropDownOther}>ÖVERIGT</a>
          <ul className="side-dropdown-menu" id="other">
            <li><Link to="/">Länkar</Link></li>
            <li><Link to="/">Nyheter</Link></li>
            <li><Link to="/">Copyright</Link></li>
            <li><Link to="/">Nöjen Och Barnkultur</Link></li>
            <li><Link to="/">Arrangörer Barn</Link></li>
            <li><Link to="/">Utländsk Marknad</Link></li>
            <li><Link to="/">Vanliga Frågor</Link></li>
          </ul>
        </li>

        <li className="side-menu-item"><a href="http://wasaplay.se/access/logform.php">ACCESS</a></li>

      </ul>
    </nav>
  );
};

export default sideDrawer;
